import { FC } from "react";
import appStyles from "../../App.module.css";
import Clear from "./icons/Clear";

interface PopupProps {
  title: string;
  onClose: () => void;
  children: JSX.Element;
  closeButton?: boolean;
  showTitle?: boolean;
  styleBenefitModal?: boolean;
  styleMoreDetailsModal?: boolean;
  styleDatePicker?: boolean;
  LoadingModal?: boolean;
}

const Popup: FC<PopupProps> = (props: PopupProps) => {
  const {
    title,
    onClose,
    children,
    closeButton = true,
    showTitle = true,
    styleBenefitModal = false,
    styleMoreDetailsModal = false,
    styleDatePicker = false,
    LoadingModal = false,
  } = props;

  return (
    <div className={appStyles.btBattlefacePluginModal}>
      <div className={appStyles.battlefacePluginModalOverlay}></div>
      <div
        className={`${appStyles.battlefacePluginModalContent} ${
          styleBenefitModal ? appStyles.btBenefitsModalContent : ""
        } ${LoadingModal ? appStyles.btLoadingModalContent : appStyles.btModalContent} `}
      >
        {closeButton && (
          <div className={`${appStyles.battlefacePluginModalHeader}`}>
            <h4 className={`${appStyles.battlefacePluginModalHeaderTitle}`}>{title}</h4>
            <p className={appStyles.battlefacePluginModalClose} onClick={() => onClose()}>
              <Clear />
            </p>
          </div>
        )}

        {title ? <div className={`${appStyles.ModalHeaderHr}`}></div> : null}

        <div
          className={`${appStyles.battlefacePluginModalBody} ${appStyles.btModalBody} ${
            styleBenefitModal ? appStyles.btBenefitsModalBody : ""
          } ${appStyles.btModalContent} ${styleMoreDetailsModal ? appStyles.btMoreDetailsModalContent : ""}`}
        >
          {showTitle && title ? <h2 className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}>{title}</h2> : null}

          <div
            className={`${appStyles.battlefacePluginModalContentData} ${
              styleDatePicker ? appStyles.ModalDatePickerContentData : ""
            } `}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
